import { post } from '../../until/axios_instans'

export const UploadFilePathname = '/api/fujian/api/v1/fujian/uploadFile'
export const FolderEnum = {US:'us'}
export const uploadFile =  (data,headers) => post(UploadFilePathname, data,headers)
